import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnSearch as UICnSearch } from './search';
import './styles/index.scss';
const CnSearch = withI18n(UICnSearch, {
    locale,
    _noHoc: true,
});
export { CnSearch };
